import LoadingStatus from 'enums/loadingStatus';

const fetchStatus = LoadingStatus.Idle;
const title = document.title;
const metaDescription = document.querySelector('meta[name="description"]')?.content;
const metaRobots = document.querySelector('meta[name="robots"]')?.content;
const canonical = document.querySelector('link[rel="canonical"]')?.href;
const heading1 = document.querySelector('[data-heading1]')?.innerText;
const heading2 = document.querySelector('[data-heading2]')?.innerText;
const footer = document.querySelector('[data-footer-content]')?.innerHTM;

export default {
    fetchStatus,
    title,
    metaDescription,
    metaRobots,
    canonical,
    heading1,
    heading2,
    footer
};